<div class="media-asset">
  <ng-container *ngIf="enableZoom$ | async; else noZoom">
    <div class="media-asset-visualizer">
      <img *ngIf="asset.previewUrl" [zoomImage]="zoomedImage" class="object-contain h-full m-auto cursor-zoom-in" [src]="asset.previewUrl | imageLoading | async" [alt]="asset.name" />
    </div>
    <div class="zoomed-image" #zoomedImage [style.background-image]="'url(' + (zoomSizeImageUrl$ | async) + ')'"></div>
  </ng-container>
  <ng-template #noZoom>
    <div class="media-asset-visualizer">
      <img *ngIf="asset.previewUrl" class="object-contain h-full m-auto" [src]="asset.previewUrl | imageLoading | async" [alt]="asset.name" />
    </div>
  </ng-template>
</div>
